(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/services/assets/components/competition-subscriber-team.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/services/assets/components/competition-subscriber-team.js');
"use strict";


const {
  useCompetitionResultSocketTeam
} = svs.components.marketplaceCompetition.services.hooks;
const CompetitionSubscriberTeam = React.memo(_ref => {
  let {
    competitionId,
    teamId
  } = _ref;
  useCompetitionResultSocketTeam(competitionId, teamId);
  return null;
});
setGlobal('svs.components.marketplaceCompetition.services.components.CompetitionSubscriberTeam', CompetitionSubscriberTeam);

 })(window);